import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { compose } from 'redux';
import { getValidationErrorMessage } from 'utils/misc';
import { actionCreators } from './store';
import AddAccount, { addAccountForm } from './AddAccount';

class AddAccountContainer extends React.Component {
  componentDidMount = () => {
    //load fake data
    this.props.getTestData();
  };

  handleAddAccount = () => {
    const { adfitNo } = this.props;
    this.props.addAccount(adfitNo, this.handleRedirect);
  };

  handleRedirect = () => {
    this.props.history.push({
      pathname: '/',
      state: { accountAdded: true }, //pass this to the account selection page to display a successful toast message
    });
  };

  render() {
    const { data, localisation, ajaxState } = this.props;
    return (
      <div>
        <AddAccount
          onSubmit={this.handleAddAccount}
          initialValues={data}
          validationError={getValidationErrorMessage(ajaxState)}
          localisation={localisation}
        />
      </div>
    );
  }
}

AddAccountContainer.propTypes = {};

const selector = formValueSelector(addAccountForm);

export default compose(
  withRouter,
  connect(
    (state) => ({
      localisation: state.localisation,
      adfitNo: selector(state, 'adfitNo'),
      ajaxState: state.ajax,
      data: state.test.data,
    }),
    {
      addAccount: actionCreators.addAccount,
      getTestData: actionCreators.getTestData,
    }
  )
)(AddAccountContainer);
